var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_13902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8333 20.0001H23.8333V13.3334H17.1667V20.0001H12.1667L20.5 28.3334L28.8333 20.0001ZM32.1667 5.00008H25.2C24.5 3.06675 22.6667 1.66675 20.5 1.66675C18.3333 1.66675 16.5 3.06675 15.8 5.00008H8.83333C8.6 5.00008 8.38333 5.01675 8.16667 5.06675C7.51667 5.20008 6.93333 5.53341 6.48333 5.98341C6.18333 6.28341 5.93333 6.65008 5.76667 7.05008C5.6 7.43341 5.5 7.86675 5.5 8.33341V31.6667C5.5 32.1167 5.6 32.5667 5.76667 32.9667C5.93333 33.3667 6.18333 33.7167 6.48333 34.0334C6.93333 34.4834 7.51667 34.8167 8.16667 34.9501C8.38333 34.9834 8.6 35.0001 8.83333 35.0001H32.1667C34 35.0001 35.5 33.5001 35.5 31.6667V8.33341C35.5 6.50008 34 5.00008 32.1667 5.00008ZM20.5 4.58341C21.1833 4.58341 21.75 5.15008 21.75 5.83341C21.75 6.51675 21.1833 7.08341 20.5 7.08341C19.8167 7.08341 19.25 6.51675 19.25 5.83341C19.25 5.15008 19.8167 4.58341 20.5 4.58341ZM32.1667 31.6667H8.83333V8.33341H32.1667V31.6667Z",
    fill: "#2A9D8C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_13902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.91983dd27c58fb73ab01c5863d6d03ad.svg";
export { ForwardRef as ReactComponent };